import { Button } from '@/shared/components/ui/button'
import { FileText } from 'lucide-react'
import { useNavigate, useParams } from 'react-router-dom'

interface NoScreenplayStateProps {
    moduleName: string
}

export const NoScreenplayState = ({ moduleName }: NoScreenplayStateProps) => {
    const { project_id } = useParams<{ project_id: string }>()
    const navigate = useNavigate()

    return (
        <div className="flex h-full w-full items-center justify-center bg-background p-4 sm:p-8">
            <div className="flex max-w-[420px] flex-col items-center justify-center rounded-xl border border-dashed bg-card p-10 text-center animate-in fade-in-50">
                <div className="mb-4 flex h-14 w-14 flex-none items-center justify-center rounded-full bg-muted">
                    <FileText className="h-6 w-6 text-muted-foreground" />
                </div>
                <h3 className="mb-2 text-lg font-semibold tracking-tight text-foreground">
                    No Screenplay Found
                </h3>
                <p className="mb-6 text-sm text-muted-foreground">
                    {moduleName} are generated from your scenes. You need to write your screenplay first.
                </p>
                <Button 
                    onClick={() => navigate(`/workspace/${project_id}/screenplay`)}
                >
                     Create Screenplay
                </Button>
            </div>
        </div>
    )
}
